import { keys } from 'ramda';
import { createRouteName, createRoutePath, childOfOrEqual } from "../router/functions";
import { SelectResults } from '../modules/booking/router/router';
import { snakeToCamelCase } from '.';
import { decode, encodeRoute } from './encoder';

/** Get the Root-Details-Tab Route paths and names from the routeName and the keyName. */
export const getDetailsTabRoutes = (routeName = 'booking_promoter', primaryKey = 'promoter_id', tabKey = 'tab') => {
  const list = routeName;
  const details = createRouteName(list, primaryKey);
  const tab = createRouteName(details, tabKey);

  const rootPath = routeName;
  const rootDetailsPath = createRoutePath(rootPath, primaryKey);
  const rootDetailsTabPath = createRoutePath(rootDetailsPath, tabKey);

  return {
    names: {
      list,
      details,
      tab,
    },
    paths: {
      list: rootPath,
      details: rootDetailsPath,
      tab: rootDetailsTabPath,
    },
    primaryKey,
  }
};
/** On Row click - go to the Details Tab Route. Takes the Router object, row object and DTRoutes and Default Tab as arguments */
export const onDetailsRowClicked = (router, row, LDTRouteObj = getDetailsTabRoutes(), defaultTab = 'overview') => {
  router.push({
    name: LDTRouteObj.names.tab,
    params: {
      [LDTRouteObj.primaryKey]: row[LDTRouteObj.primaryKey],
      tab: router.currentRoute.params.tab ? router.currentRoute.params.tab : defaultTab
    }
  });
};

/** Returns the Vue Router array for the list-details-tab Routes */
export const getDetailsTabRouteObjects = (detailsTabRoutes = getDetailsTabRoutes(), component) => {
  return keys(detailsTabRoutes.names).map(key => ({
    name: detailsTabRoutes.names[key],
    path: detailsTabRoutes.paths[key],
    component
  }))
};

/** Gets the selectable from the List-Details-tab Routes */
export const getSelectableResult = (LDTRouteObj = getDetailsTabRoutes()) => (to, from) => {
  let selectResult = SelectResults.IGNORE;
  const primaryKey = LDTRouteObj.primaryKey;
  const keyCamelCase = snakeToCamelCase(primaryKey);
  const primaryKeyValue = to && to.params && to.params[primaryKey];

  // console.log({
  //   keyCamelCase,
  //   primaryKeyValue,
  // });


  if (to && to.name === LDTRouteObj.names.list && from && childOfOrEqual(LDTRouteObj.names.details)(from.name)) {
    selectResult = SelectResults.CLOSE;
  }
  if (primaryKeyValue) {
    if (childOfOrEqual(LDTRouteObj.names.details)(to.name) && !from) {
      selectResult = SelectResults.SELECT_AUTO;
    } else if (
      childOfOrEqual(LDTRouteObj.names.details)(to.name) &&
      from &&
      childOfOrEqual(LDTRouteObj.names.details)(from.name) &&
      to.params[primaryKey] != from.params[primaryKey]
    ) {
      selectResult = SelectResults.SELECT;
    } else if (
      childOfOrEqual(LDTRouteObj.names.details)(to.name) &&
      from &&
      from.name == LDTRouteObj.names.list
    ) {
      selectResult = SelectResults.SELECT;
    } else if (!from || to.params[primaryKey] == from.params[primaryKey]) {
      selectResult = SelectResults.IGNORE;
    }
  }

  return {
    selectResult,
    [keyCamelCase]: primaryKeyValue
  }
};

/** Detects if the Current Route is child or equal of a Details Route */
export const childOfOrEqualDetails = (LDTRouteObj = getDetailsTabRoutes(), route) => {
  if (childOfOrEqual(LDTRouteObj.names.details)(route.name)) {
    return true;
  } else {
    return false;
  }
};




/** Handles the From Route query for any component */
export const handleFromRoute = (component, notFromFunc) => {
  console.log(component,);
  console.log(component?.$route);
  console.log(decode(component?.$route?.query?.from))
  if (component.$route.query && component?.$route?.query?.from) {
    component.$router.push({
      ...decode(component?.$route?.query?.from)
    });
  } else {
    notFromFunc();
  }
}

/** Router push the Current Route as the from query */
/**
 * 
 * @param {Vue} component 
 * @param {*} route 
 */
export const routeWithFrom = (component, route) => {
  // console.log(route);
  component.$router.push({
    ...route,
    query: {
      from: encodeRoute(component.$route)
    }
  });
}

/** By passing the module Route Array -> It checks if the route is child or equal of the details route */
export const getModuleChildOfOrEqualDetails = moduleRoutes => {
  const detailsRoutes = moduleRoutes.map(m => m.names.details);
  console.log('detailsRoutes', detailsRoutes)
  return route => detailsRoutes.map(r => childOfOrEqual(r)).some(f => f(route.name));
}